import { render, staticRenderFns } from "./ContactTable.vue?vue&type=template&id=1aa9b5ec"
import script from "./ContactTable.vue?vue&type=script&lang=js"
export * from "./ContactTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports